import { Component, OnInit } from '@angular/core';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { SettlementService } from '@app/api/dmc';
import { Columns } from '@shared/interfaces/table/column-config';
import { TabComponent } from '@shared/components/tabs/tab/tab.component';
import { TableComponent } from '@shared/components/table/table.component';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { ValueDetailsComponent } from '@shared/components/value-details/value-details.component';
import {
  settlementWholesaleMasterdata
} from '@shared/modals/settlement/settlement-wholesale-view-modal/settlement-wholesale.masterdata';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';

@Component({
  selector: 'app-settlement-billing-view-modal',
  imports: [
    TabComponent,
    TableComponent,
    TabsComponent,
    ValueDetailsComponent
  ],
  templateUrl: './settlement-billing-view-modal.component.html',
  styleUrl: './settlement-billing-view-modal.component.css'
})
export class SettlementBillingViewModalComponent implements OnInit {

  public id?: string;

  public billingElement: any;

  public tableConfig: TableConfig<any> = {
    columns: [
      {
        title: 'settlement.metered.view.day',
        key: 'createdTS',
        cellRenderer: DateCellComponent,
      },
      {
        title: 'settlement.wholesale.view.energysum',
        key: 'energySum',
      },
    ]
  }

  public tableData: any[] = [];

  public billingMasterdata: Columns<any>[] = settlementWholesaleMasterdata;

  constructor(
    private readonly settlementService: SettlementService,
  ) {
    ['resolutionDuration', 'unitType', 'productIdentification'].forEach((key) => {
      const el = this.billingMasterdata.find((item) => item.key === key);
      if (el) {
        const index = this.billingMasterdata.indexOf(el);
        this.billingMasterdata.splice(index, 1);
      }
    })
  }

  public ngOnInit(): void {
    if (this.id) {
      this.settlementService.settlementGetAggregatedBillingInformationGet(this.id).subscribe(
        (result) => {
          this.billingElement = result;
          this.tableData = result.timeSeries ?? [];
        }
      )
    }
  }
}
